import "./style.scss";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import React, { useState, useEffect } from "react";
import { db } from "./firebase/firebase";
import { collection, getDocs } from "firebase/firestore";

import "styles/globals.scss";
import CookieBanner from "./components/CookieBanner";

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [showContactMessage, setShowContactMessage] = useState(false);
  const [popupSource, setPopupSource] = useState('default');
  return (
    <>
      <div className="modal-wrap display-none">
        <div className="modal">
          <img src={require("./img/contact-thank-you.svg").default} alt="" />

          <p>Danke für Ihre Anfrage.</p>
          <p>Wir werden Sie benachrichtigen.</p>
          <button className="btn modal-close">Ok</button>
        </div>
      </div>

      <Header setShowPopup={setShowPopup} setShowContactMessage={setShowContactMessage} setPopupSource={setPopupSource} />
      <Home showPopup={showPopup} setShowPopup={setShowPopup} showContactMessage={showContactMessage} setShowContactMessage={setShowContactMessage} popupSource={popupSource} setPopupSource={setPopupSource} />
      <Footer />
      <CookieBanner />
    </>
  );
}

export default App;
